var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorks1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 230,
    viewBox: "0 0 240 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-HowItWorks1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 230
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HowItWorks1",
    clipPath: "url(#clip-HowItWorks1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13727",
    "data-name": "Group 13727",
    transform: "translate(-396 -1272)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_751",
    "data-name": "Ellipse 751",
    cx: 113.802,
    cy: 114,
    rx: 113.802,
    ry: 114,
    transform: "translate(396 1272)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13708",
    "data-name": "Group 13708",
    transform: "translate(445.105 1322.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14275",
    "data-name": "Path 14275",
    d: "M339.435,161.835c-1.738-.021-3.477-.016-5.216-.011-.8,0-1.6,0-2.386,0l-2.066,0-2.156,0q-1.217,0-2.435.006a17.254,17.254,0,0,0-17.108,17.1c-.023,4.81-.014,9.608,0,14.077.006,2.531,1.608,4.3,3.893,4.3h0c2.286,0,3.888-1.769,3.9-4.3q.011-3.177,0-6.353,0-3.154,0-6.308c.022-6.7,4.04-10.709,10.748-10.734,1.826-.006,3.653,0,5.481,0,2.455,0,4.912.006,7.367-.013a3.881,3.881,0,1,0-.026-7.758Z",
    transform: "translate(-308.053 -161.819)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14276",
    "data-name": "Path 14276",
    d: "M339.271,335.555c-2.186-.01-4.372-.008-6.558-.006-2.047,0-4.095,0-6.143,0-6.672-.027-10.674-4-10.705-10.623-.01-2-.007-4-.005-6.005s.005-4.019-.005-6.028A3.958,3.958,0,0,0,312,308.674h-.051a3.667,3.667,0,0,0-2.627,1.053,4.457,4.457,0,0,0-1.252,3.21c-.017,4.385-.017,8.8,0,13.133a17.411,17.411,0,0,0,14.065,16.966,26.521,26.521,0,0,0,5.75.278c1.147-.028,2.231-.055,3.269.012l2.8,0c1.912,0,3.636.007,5.36-.008a3.893,3.893,0,1,0-.037-7.766Z",
    transform: "translate(-308.053 -213.887)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14277",
    "data-name": "Path 14277",
    d: "M457.787,169.6c2.314.008,4.627.006,6.941.006l2.821,0q1.466,0,2.932,0c6.886.017,10.85,3.944,10.872,10.772q.01,2.758,0,5.517,0,2.781,0,5.561c.009,2.544,1.6,4.336,3.873,4.359a3.706,3.706,0,0,0,2.655-1.056,4.491,4.491,0,0,0,1.263-3.23c.019-5.074.019-8.975,0-12.649a17.54,17.54,0,0,0-12.8-16.491,24.062,24.062,0,0,0-6.909-.53c-1.239.025-2.41.05-3.547-.033h-8.168a3.95,3.95,0,0,0-4.234,3.858,3.621,3.621,0,0,0,1.053,2.647A4.514,4.514,0,0,0,457.787,169.6Z",
    transform: "translate(-359.369 -161.823)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14278",
    "data-name": "Path 14278",
    d: "M504.34,237.884a4.483,4.483,0,0,0-1.255-3.221,3.666,3.666,0,0,0-2.633-1.064h-.027c-2.279.014-3.872,1.795-3.875,4.33q-.017,13.6,0,27.2a4.485,4.485,0,0,0,1.25,3.226,3.659,3.659,0,0,0,2.63,1.064h.029c2.277-.015,3.873-1.8,3.88-4.341q.015-4.7.005-9.405l0-4.034,0-4.2Q504.35,242.66,504.34,237.884Z",
    transform: "translate(-374.558 -187.269)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14279",
    "data-name": "Path 14279",
    d: "M416.12,356.862a3.688,3.688,0,0,0,1.066-2.682c-.008-2.269-1.787-3.858-4.326-3.866q-4.7-.015-9.406-.005l-3.913,0-4.144,0-3.889,0q-2.721,0-5.442.012a4.311,4.311,0,0,0-3,1.135,3.746,3.746,0,0,0-1.131,2.759,3.917,3.917,0,0,0,4.172,3.87c8.274.015,17.04.016,26.8,0A4.479,4.479,0,0,0,416.12,356.862Z",
    transform: "translate(-334.122 -228.647)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14280",
    "data-name": "Path 14280",
    d: "M308.068,266.288a4.485,4.485,0,0,0,1.27,3.234,3.585,3.585,0,0,0,2.654,1.05,3.959,3.959,0,0,0,3.864-4.217c.015-8.413.015-17.2,0-26.115a4.419,4.419,0,0,0-1.229-3.185,3.709,3.709,0,0,0-2.668-1.064h-.036a3.932,3.932,0,0,0-3.854,4.188c-.014,3.024-.01,6.048-.007,9.071l0,3.9,0,3.89Q308.059,261.666,308.068,266.288Z",
    transform: "translate(-308.055 -188.117)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14281",
    "data-name": "Path 14281",
    d: "M386.027,169.6c8.342.019,16.991.02,25.705,0a4.268,4.268,0,0,0,3.051-1.215,3.749,3.749,0,0,0,1.094-2.683,3.98,3.98,0,0,0-4.194-3.866q-4.468-.02-8.936-.007l-3.755,0-3.943,0q-1.918,0-3.837,0-2.613,0-5.226.014a3.886,3.886,0,0,0-4.061,3.842,3.736,3.736,0,0,0,1.07,2.707A4.211,4.211,0,0,0,386.027,169.6Z",
    transform: "translate(-334.117 -161.82)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14282",
    "data-name": "Path 14282",
    d: "M535.318,329.211c-1.476-4.02-4.007-7.416-6.5-10.838-6.05-8.306-12-16.683-18.136-24.926a12.259,12.259,0,0,0-20.709,1.255c-.538.942-.861.846-1.6.3a11.311,11.311,0,0,0-6.962-2.448,12.145,12.145,0,0,0-11.144,6.384c-.485.853-.831.8-1.548.269a12.316,12.316,0,0,0-17.873,3.407c-.806,1.272-.81,1.276-1.8.041-2.816-3.512-5.59-7.061-8.453-10.536-6.352-7.711-17.859-6.089-21.4,3.047-1.793,4.63-.648,8.814,2.391,12.6q18.22,22.729,36.419,45.474c.305.382.594.778,1.036,1.357-8.553.384-16.822.777-25.092,1.119-6.741.279-12.05,4.271-13.9,10.533-1.833,6.193,1.877,12.134,8.177,12.85q30.28,3.441,60.575,6.738a32.475,32.475,0,0,0,20.087-4.385c5.935-3.442,10.872-8.229,16.283-12.378a24.456,24.456,0,0,0,3.917-3.791Q542.582,349.037,535.318,329.211ZM521.3,363.6c-4.244,3.576-8.584,7.05-13.039,10.357a26.293,26.293,0,0,1-18.77,5.235c-9.881-.99-19.741-2.176-29.61-3.278l0,.02c-9.96-1.113-19.913-2.29-29.883-3.3-3.345-.339-4.538-2.388-3.181-5.523a7.35,7.35,0,0,1,6.8-4.681c7.542-.38,15.087-.7,22.631-1.04,3.09-.139,6.182-.256,9.271-.408a3.494,3.494,0,0,0,3.281-2.056,3.413,3.413,0,0,0-.665-3.676c-.3-.4-.617-.787-.931-1.178q-20.169-25.187-40.347-50.369a6.266,6.266,0,0,1-1.742-4.841,5.444,5.444,0,0,1,3.528-4.638,5.232,5.232,0,0,1,5.626.918,12.228,12.228,0,0,1,1.666,1.793q13.357,16.659,26.7,33.332c.944,1.179,1.989,2.15,3.678,1.847a3.2,3.2,0,0,0,2.445-4.545,8.357,8.357,0,0,0-1.12-1.7c-3.486-4.375-7.006-8.723-10.478-13.11-1.955-2.471-1.923-5.353-.006-7.468a5.644,5.644,0,0,1,8.806.4c3.587,4.411,7.118,8.867,10.67,13.305a5.018,5.018,0,0,0,2.044,1.756,3.2,3.2,0,0,0,3.616-.869,3.04,3.04,0,0,0,.458-3.658,9.242,9.242,0,0,0-.986-1.466c-1.637-2.069-3.315-4.1-4.933-6.187-2.134-2.746-1.83-6.1.69-8.133s5.9-1.61,8.109,1.059c1.8,2.173,3.526,4.4,5.3,6.591a3.669,3.669,0,0,0,3.107,1.686c2.731-.167,4.024-2.907,2.457-5.317a6.365,6.365,0,0,1-1.356-4.441,5.467,5.467,0,0,1,3.95-4.745,5.353,5.353,0,0,1,6.013,1.821c1.854,2.417,3.614,4.9,5.4,7.372,5.3,7.329,10.744,14.566,15.87,22.018A28.037,28.037,0,0,1,521.3,363.6Z",
    transform: "translate(-346.968 -206.273)",
    fill: "#272c48"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorks1);
export default __webpack_public_path__ + "static/media/HowItWorks1.f6f5bcb87deeb0c4c07905194bdd641c.svg";
export { ForwardRef as ReactComponent };